import { namespace } from '../constants'
import { prop, compose } from 'ramda'

const root = prop(namespace)

export const comps = compose(prop('comps'), root)
export const compsData = compose(prop('compsData'), comps)
export const templateName = compose(prop('templateName'), comps)
export const projectName = compose(prop('projectName'), comps)
export const projectNameCopy = compose(prop('projectNameCopy'), comps)
export const resetflag = compose(prop('resetflag'), comps)
export const toggleSettings = compose(prop('toggleSettings'), comps)
export const isPropImagesNotLoaded = compose(prop('isPropImagesNotLoaded'), comps)
export const templateDataLimits = compose(prop('templateDataLimits'), comps)
export const templates = compose(prop('templates'), comps)
export const salesTemplates = compose(prop('salesTemplates'), comps)
export const studentHousingTemplates = compose(prop('studentHousingTemplates'), comps)
export const barChartData = compose(prop('barChartData'), comps)
export const fpBarChartData = compose(prop('fpBarChartData'), comps)
export const fpSummaryData = compose(prop('fpSummaryData'), comps)
export const barChartSettings = compose(prop('barChartSettings'), comps)
export const themeColors = compose(prop('themeColors'), comps)
export const donutChartThemeColors = compose(prop('donutChartThemeColors'), comps)
export const propertyFields = compose(prop('propertyFields'), comps)
export const subjectPropertyFields = compose(prop('subjectPropertyFields'), comps)
export const summaryTableColumns = compose(prop('summaryTableColumns'), comps)
export const unitMixTableColumns = compose(prop('unitMixTableColumns'), comps)
export const isDialogOpen = compose(prop('isDialogOpen'), comps)
export const dialogType = compose(prop('dialogType'), comps)
export const selectedProjectId = compose(prop('selectedProjectId'), comps)
export const status = compose(prop('status'), comps)
export const dealNumber = compose(prop('dealNumber'), comps)
export const office = compose(prop('office'), comps)
export const isPortfolio = compose(prop('isPortfolio'), comps)
export const getOffices = compose(prop('regions'), comps)
export const recentProjects = compose(prop('recentProjects'), comps)
export const allProjects = compose(prop('allProjects'), comps)
export const count = compose(prop('count'), comps)
export const recentCount = compose(prop('recentCount'), comps)
export const fetchProjectLoading = compose(prop('fetchProjectLoading'), comps)
export const fetchRecentProjectLoading = compose(prop('fetchRecentProjectLoading'), comps)
export const pagination = compose(prop('pagination'), comps)
export const isDeleted = compose(prop('isDeleted'), comps)
export const regions = compose(prop('regions'), comps)
export const totalProjectsText = compose(prop('totalProjectsText'), comps)
export const favoriteClick = compose(prop('favoriteClick'), comps)
export const citylookUp = compose(prop('citylookUp'), comps)
export const ownerlookUp = compose(prop('ownerlookUp'), comps)
export const fpSummaryTableColumns = compose(prop('fpSummaryTableColumns'), comps)
export const summaryDisclaimerText = compose(prop('summaryDisclaimerText'), comps)
export const compsWithSubjectProperty = compose(prop('compsWithSubjectProperty'), comps)
export const isSubjectPropertyDeleted = compose(prop('isSubjectPropertyDeleted'), comps)
export const propertySearchData = compose(prop('propertySearchData'), comps)
export const listInfo = compose(prop('listInfo'), comps)
export const listInfoLoading = compose(prop('listInfoLoading'), comps)
export const polarisPropertySearchCriteriaId = compose(prop('polarisPropertySearchCriteriaId'), comps)
export const omniViewPropertyListId = compose(prop('omniViewPropertyListId'), comps)
export const isPropertyDataReady = compose(prop('isPropertyDataReady'), comps)
export const listName = compose(prop('listName'), comps)
export const isListRefreshed = compose(prop('isListRefreshed'), comps)
export const activeTabIndex = compose(prop('activeTabIndex'), comps)
export const recentMapProjects = compose(prop('recentMapProjects'), comps)
export const mapProjects = compose(prop('mapProjects'), comps)
export const totalMapsCount = compose(prop('totalMapsCount'), comps)
export const isMapsSelected = compose(prop('isMapsSelected'), comps)
export const mapPageNo = compose(prop('mapPageNo'), comps)
